var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "view-point-app-container itinerary",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _vm.currentItineraryPlanningRow && _vm.currentItineraryPlanningRow.theDay
        ? _c(
            "el-dialog",
            {
              attrs: {
                top: _vm.dialogTopMargin,
                title: "行程規劃資料",
                visible: _vm.currentItineraryPlanningRowVisible,
                width: "85%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.currentItineraryPlanningRowVisible = $event
                },
              },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [_vm._v("行程設定")]),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            float: "right",
                            padding: "6px 15px",
                            "margin-left": "10px",
                          },
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              _vm.currentItineraryPlanningRowVisible = false
                            },
                          },
                        },
                        [_vm._v("關 閉")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.planningTab,
                        callback: function ($$v) {
                          _vm.planningTab = $$v
                        },
                        expression: "planningTab",
                      },
                    },
                    [
                      _vm.currentItineraryPlanningRow.theDay
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "精彩行程", name: "thisTimes" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      staticClass: "itinerary",
                                      attrs: {
                                        disabled: true,
                                        "label-width": "130px",
                                        size: "mini",
                                        "label-position": "right",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出發時間" } },
                                        [
                                          _c("el-time-select", {
                                            attrs: {
                                              "picker-options": {
                                                start: "08:00",
                                                step: "00:10",
                                                end: "23:30",
                                              },
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              placeholder: "出發時間",
                                            },
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.departureTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "departureTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.departureTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出發集合地點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.assemblingPlace,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "assemblingPlace",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.assemblingPlace",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "旅館名稱" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.hotelName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "hotelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.hotelName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "上午景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.morningSights,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "morningSights",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.morningSights",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "下午景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.afternoonAttractions,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "afternoonAttractions",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.afternoonAttractions",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "早餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.breakfast,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "breakfast",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.breakfast",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "午餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.lunch,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "lunch",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.lunch",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "晚餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.dinner,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "dinner",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.dinner",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      staticClass: "itinerary",
                                      attrs: {
                                        disabled: true,
                                        "label-width": "130px",
                                        size: "mini",
                                        "label-position": "right",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "晚間景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.eveningAttractions,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "eveningAttractions",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.eveningAttractions",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "預計返回旅館時間" },
                                        },
                                        [
                                          _c("el-time-select", {
                                            attrs: {
                                              "picker-options": {
                                                start: "08:00",
                                                step: "00:10",
                                                end: "23:30",
                                              },
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              placeholder: "預計返回旅館時間",
                                            },
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.returnHotelTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "returnHotelTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.returnHotelTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "本日行程注意事項" },
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.notesOnToday,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "notesOnToday",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.notesOnToday",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("el-form-item", {
                                        attrs: { label: "行程手冊上傳" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.currentItineraryPlanningRow.thisTime
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "行程規劃", name: "thisDays" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "overflow-y": "scroll",
                                    height: "500px",
                                  },
                                },
                                _vm._l(
                                  _vm.currentItineraryPlanningRow.thisTime.data,
                                  function (item, index) {
                                    return _c(
                                      "el-form",
                                      {
                                        key: index,
                                        staticClass: "itinerary",
                                        attrs: {
                                          disabled: true,
                                          inline: true,
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: { label: "", size: "mini" },
                                          },
                                          [
                                            _c("el-tag", [
                                              _vm._v("Day" + _vm._s(index + 1)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "widh-input",
                                            staticStyle: { width: "90%" },
                                            attrs: { label: "行程說明" },
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              {
                                                staticClass: "line",
                                                attrs: { span: 24 },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "行程說明",
                                                  },
                                                  model: {
                                                    value: item.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: "新增景點",
            visible: _vm.viewPointDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.viewPointDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "vsForm",
                  attrs: {
                    model: _vm.vsForm,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "使用區域",
                        prop: "countryAreaList",
                        rules: [
                          {
                            required: true,
                            message: "請輸入景點區域",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          props: {
                            checkStrictly: true,
                            expandTrigger: "hover",
                          },
                          placeholder: "請選擇",
                          filterable: "",
                          options: _vm.travelAttractionsMenu,
                        },
                        model: {
                          value: _vm.vsForm.countryAreaList,
                          callback: function ($$v) {
                            _vm.$set(_vm.vsForm, "countryAreaList", $$v)
                          },
                          expression: "vsForm.countryAreaList",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "名稱",
                        prop: "viewPointName",
                        rules: [
                          {
                            required: true,
                            message: "請輸入景點名稱",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.vsForm.viewPointName,
                          callback: function ($$v) {
                            _vm.$set(_vm.vsForm, "viewPointName", $$v)
                          },
                          expression: "vsForm.viewPointName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.funcName + "座標" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "北緯(lat)",
                                    prop: "lat",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸座標北緯度",
                                        trigger: "blur",
                                      },
                                      {
                                        type: "number",
                                        message: "座標緯度必須為數字",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.vsForm.lat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.vsForm, "lat", _vm._n($$v))
                                      },
                                      expression: "vsForm.lat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "東經(lng)",
                                    prop: "lng",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸座標東經度",
                                        trigger: "blur",
                                      },
                                      {
                                        type: "number",
                                        message: "座標經度必須為數字",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.vsForm.lng,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.vsForm, "lng", _vm._n($$v))
                                      },
                                      expression: "vsForm.lng",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.viewPointDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveViewpointData },
                },
                [_vm._v("確 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.currentPositionData &&
      _vm.currentPositionData.records &&
      _vm.currentPositionData.records.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "定位足跡紀錄",
                visible: _vm.positionDialogVisible,
                top: "2%",
                width: "70%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.positionDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.currentPositionData.records,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "600px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4178052834
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "日期", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.date))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1531225394
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "left", label: "景點", width: "250" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.viewPointName)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3218238656
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "到達時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.startTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3779423219
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "離開時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.leaveTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          824829608
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "停留時間",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.dwellTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          89793029
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "北緯", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lat
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lat))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1203890484
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "東經", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lng
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lng))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3511418036
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "功能", width: "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.lat && scope.row.lng
                                  ? [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    icon: "el-icon-position",
                                                    type: "success",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.googleMap(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看Google地圖")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-plus",
                                                    type: "warning",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addToViewpoint(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("添加至景點管理")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogVisible,
            width: "90%",
          },
          on: {
            open: _vm.getDataReference,
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": _vm.formLabelWidth,
                    disabled: false,
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _vm.form.id
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "狀態" } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm._f("statusFilter")(
                                          _vm.form.status
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.form.statusDesc))]
                                  ),
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { type: "success" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "申請時間：" + _vm.form.buildDate
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: "申請項目", prop: "applyType" } },
                            [
                              _c("el-tag", [
                                _vm._v(_vm._s(_vm.form.applyTypeDesc)),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "資訊需求團號",
                                prop: "applyTourNo",
                                rules: [
                                  {
                                    required: true,
                                    message: "請填寫紀錄資訊需求團號",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v(_vm._s(_vm.form.applyTourNo)),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "資訊需求團名",
                                prop: "applyTravelName",
                                rules: [
                                  {
                                    required: true,
                                    message: "請填寫紀錄資訊需求團號",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v(_vm._s(_vm.form.applyTravelName)),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "資訊需求日期時間範圍",
                                prop: "applyDates",
                                rules: [
                                  {
                                    required: true,
                                    message: "請選擇資訊需求日期時間範圍",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-date-picker", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.dateInfoLoading,
                                    expression: "dateInfoLoading",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: true,
                                  "picker-options": _vm.pickerOptions,
                                  type: "datetimerange",
                                  format: "yyyy-MM-dd HH:mm",
                                  "value-format": "yyyy-MM-dd HH:mm",
                                  "range-separator": "至",
                                  "start-placeholder": "開始日期",
                                  "end-placeholder": "結束日期",
                                },
                                model: {
                                  value: _vm.form.applyDates,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "applyDates", $$v)
                                  },
                                  expression: "form.applyDates",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.showUserOptionsApplyTypeIDs.includes(
                            _vm.form.applyType
                          )
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "資訊需求人物姓名",
                                    prop: "applyUserID",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請填寫紀錄資訊需求人物姓名",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.dateInfoLoading,
                                          expression: "dateInfoLoading",
                                        },
                                      ],
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        placeholder: "請選擇旅客",
                                      },
                                      model: {
                                        value: _vm.form.applyUserID,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "applyUserID", $$v)
                                        },
                                        expression: "form.applyUserID",
                                      },
                                    },
                                    _vm._l(_vm.travelers, function (item) {
                                      return _c("el-option", {
                                        key: item.userID,
                                        attrs: {
                                          label: "" + item.name,
                                          value: item.userID,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "applyDescription",
                                label: "發生經過",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "請詳細填寫發生經過，以及需求何種紀錄為參考依據",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("span", [
                                    _vm._v(
                                      "請詳細填寫發生經過，以及需求何種紀錄為參考依據。"
                                    ),
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      id: "remarkAreaContent",
                                      type: "textarea",
                                      rows: 10,
                                    },
                                    model: {
                                      value: _vm.form.applyDescription,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "applyDescription",
                                          $$v
                                        )
                                      },
                                      expression: "form.applyDescription",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { offset: 1, span: 14 } },
                        [
                          _vm.form.applyType != 8
                            ? _c("el-alert", {
                                attrs: {
                                  title:
                                    "自" +
                                    _vm.form.applyDates[0] +
                                    "至" +
                                    _vm.form.applyDates[0] +
                                    "，申請【" +
                                    _vm.form.applyTypeDesc +
                                    "】資料共計：" +
                                    _vm.referenceData.length +
                                    " 筆。日期最新排在最上方。",
                                  closable: false,
                                  type: "success",
                                },
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "relative",
                                height: "80%",
                              },
                            },
                            [
                              _vm.form.applyType == 8
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticStyle: { margin: "5px" },
                                          attrs: { type: "success" },
                                        },
                                        [_vm._v("請輸入審核說明")]
                                      ),
                                      _c("el-input", {
                                        staticStyle: { height: "20%" },
                                        attrs: {
                                          disabled: _vm.form.status != 1,
                                          type: "textarea",
                                          rows: 20,
                                          placeholder: "請輸入說明",
                                        },
                                        model: {
                                          value: _vm.successRemark,
                                          callback: function ($$v) {
                                            _vm.successRemark = $$v
                                          },
                                          expression: "successRemark",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 1
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "時間",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildDate
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4108465086
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "建立者",
                                          width: "130",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildUserName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4095719996
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "公告內容",
                                          width: "300",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.data.bulletinBoard
                                                    ? _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "cuttingText"
                                                            )(
                                                              scope.row.data
                                                                .bulletinBoard
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                          },
                                                        },
                                                        [_vm._v("無內容")]
                                                      ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1325396211
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "查看",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.form.applyType == 1 &&
                                                  scope.row.data.bulletinBoard
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            disabled: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewReferenceData(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("查看內容")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2536085378
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 2
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "時間",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildDate
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4108465086
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "建立者",
                                          width: "130",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildUserName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4095719996
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "建議攜帶物品",
                                          width: "400",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.form.applyType == 2
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            disabled: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewReferenceData(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "查看攜帶物品紀錄"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          250330172
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 3
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "時間",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildDate
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4108465086
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "建立者",
                                          width: "130",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildUserName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4095719996
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "查看說明會影片",
                                          width: "400",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.form.applyType == 3 &&
                                                  scope.row.data.fileInfo &&
                                                  scope.row.data.fileInfo
                                                    .length > 0 &&
                                                  scope.row.data.fileInfo[0]
                                                    .files &&
                                                  scope.row.data.fileInfo[0]
                                                    .files.length > 0
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            disabled: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewReferenceData(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "查看說明會影片"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3502882122
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 4
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "日期",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.date)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2369769736
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "查看聊天紀錄",
                                          width: "400",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.charMsgInfos
                                                    .length > 0
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            disabled: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewReferenceData(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "查看與領隊聊天紀錄"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          207710606
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 5
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "日期",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.date)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2369769736
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "時間",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.time)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2683714473
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "檔名",
                                          width: "200",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.fileName)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2483168541
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "大小",
                                          width: "110",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.size)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3088641529
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "查看導覽紀錄",
                                          width: "200",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        icon: "el-icon-video-play",
                                                        type: "primary",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("點我播放")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2506225558
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 6
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "日期",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(scope.row.date)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2369769736
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "景點數量",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: { type: "danger" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.records
                                                            .length
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" 個景點 "),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          588023489
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "查看足跡紀錄",
                                          width: "400",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看足跡紀錄")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2065810261
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.applyType == 7
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.listLoading,
                                          expression: "listLoading",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        data: _vm.referenceData,
                                        border: "",
                                        fit: "",
                                        "highlight-current-row": "",
                                        height: "600px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "項次",
                                          width: "60",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4178052834
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "時間",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildDate
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4108465086
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "建立者",
                                          width: "130",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.buildUserName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4095719996
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "每日行程",
                                          width: "400",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.form.applyType == 7
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            disabled: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.viewReferenceData(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("查看每日行程")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2703394930
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div"),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.form.status == 1 ? "取 消" : "關 閉"))]
              ),
              _vm.form.status == 1
                ? _c(
                    "el-button",
                    { attrs: { type: "warning" }, on: { click: _vm.reject } },
                    [_vm._v("駁 回")]
                  )
                : _vm._e(),
              _vm.form.status == 1
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveData } },
                    [_vm._v("審核確認")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.currentChatData && _vm.currentChatData.charMsgInfos.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "與領隊聊天紀錄",
                visible: _vm.chatDialogVisible,
                top: "2%",
                width: "450px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.chatDialogVisible = $event
                },
              },
            },
            [
              _vm.currentChatData.leaderInfo
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        height: "100%",
                        padding: "10px",
                      },
                    },
                    [
                      _c("div", { staticClass: "center" }, [
                        _c("div", { staticClass: "chat" }, [
                          _c("div", { staticClass: "contact bar" }, [
                            _c("div", {
                              staticClass: "pic",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  _vm.currentChatData.leaderInfo.avatar +
                                  ")",
                              },
                            }),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(_vm.currentChatData.leaderInfo.name)
                              ),
                            ]),
                            _c("div", { staticClass: "seen" }, [
                              _vm._v(_vm._s(_vm.currentChatData.date)),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "messages", attrs: { id: "chat" } },
                            [
                              _c("div", { staticClass: "time" }, [
                                _vm._v("聊天紀錄"),
                              ]),
                              _vm._l(
                                _vm.currentChatData.charMsgInfos,
                                function (item, index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: index,
                                        class: {
                                          message: true,
                                          "chat-user":
                                            item.from !=
                                            _vm.currentChatData.leaderInfo.name,
                                          "chat-leader":
                                            item.from ==
                                            _vm.currentChatData.leaderInfo.name,
                                        },
                                        staticStyle: { position: "relative" },
                                      },
                                      [
                                        item.from !=
                                        _vm.currentChatData.leaderInfo.name
                                          ? _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "chat-time-chat-user",
                                              },
                                              [_vm._v(_vm._s(item.time))]
                                            )
                                          : _vm._e(),
                                        item.chatType == 1
                                          ? _c("span")
                                          : _vm._e(),
                                        _vm._v(" " + _vm._s(item.msg) + " "),
                                        item.chatType == 2
                                          ? [
                                              item.fileInfo
                                                ? _c("el-image", {
                                                    staticStyle: {
                                                      width: "80px",
                                                    },
                                                    attrs: {
                                                      src: item.fileInfo.url,
                                                      fit: "fill",
                                                      "preview-src-list": [
                                                        item.fileInfo.url,
                                                      ],
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v("圖片加載失敗"),
                                                  ]),
                                            ]
                                          : _vm._e(),
                                        item.from ==
                                        _vm.currentChatData.leaderInfo.name
                                          ? _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "chat-time-chat-leader",
                                              },
                                              [_vm._v(_vm._s(item.time))]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "input" }, [
                            _c("i", { staticClass: "fas fa-camera" }),
                            _c("i", { staticClass: "far fa-laugh-beam" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  "【" +
                                    _vm.currentChatData.userInfo.name +
                                    "】與【" +
                                    _vm.currentChatData.leaderInfo.name +
                                    "】領隊聊天紀錄"
                                ) +
                                " "
                            ),
                            _c("i", { staticClass: "fas fa-microphone" }),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            top: _vm.dialogTopMargin,
            title: "說明會影片",
            visible: _vm.seminarMovieDialogVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.seminarMovieDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("video", {
              attrs: {
                src: _vm.currentSeminarMovieUrl,
                autoplay: "",
                controls: "",
                width: "500",
              },
            }),
          ]),
        ]
      ),
      _vm.currentCarryRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: "攜帶物品異動紀錄",
                visible: _vm.carryDialogVisible,
                width: "90%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.carryDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "relative",
                          height: "80%",
                          margin: "5px",
                        },
                      },
                      [
                        _c(
                          "el-alert",
                          {
                            staticStyle: { margin: "5px" },
                            attrs: { type: "success", closable: false },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                "建議攜帶物品 共" +
                                  _vm.currentCarryRow.data.recommended.items
                                    .length +
                                  " 項"
                              )
                            ),
                          ]
                        ),
                        _vm.currentCarryRow.applyType == 2
                          ? _c(
                              "el-table",
                              {
                                attrs: {
                                  size: "mini",
                                  data: _vm.currentCarryRow.data.recommended
                                    .items,
                                  border: "",
                                  fit: "",
                                  "highlight-current-row": "",
                                  height: "600px",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "項次",
                                    width: "60",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(scope.$index + 1)),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4178052834
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "品項",
                                    width: "300",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.description)
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1516911488
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticStyle: { position: "relative", height: "80%" } },
                      [
                        _c(
                          "el-alert",
                          {
                            staticStyle: { margin: "5px" },
                            attrs: { type: "error", closable: false },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                "必帶物品 共" +
                                  _vm.currentCarryRow.data.required.items
                                    .length +
                                  " 項"
                              )
                            ),
                          ]
                        ),
                        _vm.currentCarryRow.applyType == 2
                          ? _c(
                              "el-table",
                              {
                                attrs: {
                                  size: "mini",
                                  data: _vm.currentCarryRow.data.required.items,
                                  border: "",
                                  fit: "",
                                  "highlight-current-row": "",
                                  height: "600px",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "項次",
                                    width: "60",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(scope.$index + 1)),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4178052834
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "品項",
                                    width: "300",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.description)
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1516911488
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.logs.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: "作業紀錄",
                visible: _vm.logDialogVisible,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.logDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { position: "relative", height: "80%" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.logs,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "400px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4178052834
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "日期", width: "220" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [_vm._v(_vm._s(row.buildDate))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2888226278
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "狀態", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm._f("statusFilter")(
                                          scope.row.beforeStatus
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.beforeStatusDesc))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4216272916
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "狀態(異)",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm._f("statusFilter")(
                                          scope.row.status
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.statusDesc))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          841128692
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "備註", width: "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.remark)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          186672324
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "作業人員",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.buildUserName)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          706569030
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.logDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: "2%",
            title: "駁回申請",
            visible: _vm.rejectDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-tag",
            { staticStyle: { margin: "5px" }, attrs: { type: "success" } },
            [_vm._v("請輸入駁回原因")]
          ),
          _c("el-input", {
            staticStyle: { height: "20%" },
            attrs: {
              type: "textarea",
              rows: 20,
              placeholder: "請輸入駁回原因",
            },
            model: {
              value: _vm.rejectRemark,
              callback: function ($$v) {
                _vm.rejectRemark = $$v
              },
              expression: "rejectRemark",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.rejectHandle } },
                [_vm._v("確 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "查詢" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入需求人姓名或旅遊團名稱" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getList($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "狀態" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "請選擇" },
                      model: {
                        value: _vm.listQuery.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "status", $$v)
                        },
                        expression: "listQuery.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "申請項目", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tag", [_vm._v(_vm._s(scope.row.applyTypeDesc))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("statusFilter")(scope.row.status),
                            },
                          },
                          [_vm._v(_vm._s(scope.row.statusDesc))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "團號", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.applyTourNo))]),
                        _c(
                          "div",
                          [
                            _c("el-tag", [
                              _vm._v(" " + _vm._s(row.applyTravelName) + " "),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "需求旅行社", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tag", [
                          _vm._v(
                            _vm._s(scope.row.agencyCode) +
                              " - " +
                              _vm._s(scope.row.agencyName)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "需求人姓名", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.applyUserName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "申請時間範圍", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.applyBeginDate) +
                              " - " +
                              _vm._s(scope.row.applyEndDate)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "查看", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "紀錄", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.getRecordRequestLog(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("紀錄")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }